import { gql, useQuery } from '@apollo/client'
import { RouteComponentProps } from '@reach/router'
import { format, parseISO } from 'date-fns'
import { Link } from 'gatsby'

const rapidSessionsQuery = gql`
  query RapidSessionsList {
    rapidSessions {
      id
      startDate
      reference
      thirdParty {
        id
      }
    }
  }
`
const ChooseSession = (props: RouteComponentProps) => {
  const { loading, error, data } = useQuery(rapidSessionsQuery)

  if (loading) {
    return <p>Loading...</p>
  }

  if (error) throw error

  return (
    <section className="section">
      <div className="container">
        <h1 className="title">Choose a session</h1>
        <ul>
          {data.rapidSessions.map((s) => (
            <li key={s.id}>
              <Link to={`/dashboard/rapid-testing/capture-results?sessionId=${s.id}`}>
                <div className="card">
                  <div className="card-content">
                    <div className="media">
                      <div className="media-content">
                        <p className="title is-4">
                          {format(parseISO(s.startDate), 'dd/MM/yyyy')} &mdash; {s.thirdParty.id}
                        </p>
                        <p className="subtitle is-6">{s.reference}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default ChooseSession
